import pickBy from 'lodash/pickBy'
import FilterComponents from 'components/Filters/FilterPanel/subcomponents'

const extractComponents = (configuration = {}, position) =>
  Object.entries(pickBy(configuration, (item) => item.order === position) ?? {})
    .map(([key, values]) => {
      const Component = FilterComponents[values.typeAsButtonControl ?? values.type]

      if (!Component) {
        return null
      }

      return {
        key,
        values,
        Component,
        className: configuration[key]?.className ?? '',
      }
    })
    .filter(Boolean)

export default extractComponents
